import { create } from 'zustand';

type FacturacionCategoria = 'VENTA' | 'DEVOLUCION' | 'COSTO' | 'VARIACION' | 'VOLUMEN';
type FacturacionTipo = FacturacionCategoria | 'TODOS';
type EstadoFilter = 'TODOS' | 'REVISION' | 'CERRADO';

interface PeriodsUIState {
  // Filtros de la lista
  searchQuery: string;
  estadoFilter: EstadoFilter;
  companiaFilter: string;
  anioFilter: string;

  // Estado del diálogo de detalle
  activeTab: string;
  facturacionFilter: FacturacionTipo;
  gastoSearchQuery: string;
  gastoCentroCostoFilter: string;
  expandedGroups: Set<string>;

  setSearchQuery: (value: string) => void;
  setEstadoFilter: (value: EstadoFilter) => void;
  setCompaniaFilter: (value: string) => void;
  setAnioFilter: (value: string) => void;

  setActiveTab: (value: string) => void;
  setFacturacionFilter: (value: FacturacionTipo) => void;
  setGastoSearchQuery: (value: string) => void;
  setGastoCentroCostoFilter: (value: string) => void;
  setExpandedGroups: (value: Set<string>) => void;
  toggleExpandedGroup: (descripcion: string) => void;
  expandAllGroups: (descripciones: string[]) => void;
  collapseAllGroups: () => void;

  reset: () => void;
}

const initialState = {
  searchQuery: '',
  estadoFilter: 'TODOS' as EstadoFilter,
  companiaFilter: 'TODOS',
  anioFilter: 'TODOS',

  activeTab: 'facturacion',
  facturacionFilter: 'TODOS' as FacturacionTipo,
  gastoSearchQuery: '',
  gastoCentroCostoFilter: 'TODOS',
  expandedGroups: new Set<string>(),
};

export const usePeriodsUIStore = create<PeriodsUIState>((set, get) => ({
  ...initialState,

  setSearchQuery: searchQuery => set({ searchQuery }),
  setEstadoFilter: estadoFilter => set({ estadoFilter }),
  setCompaniaFilter: companiaFilter => set({ companiaFilter }),
  setAnioFilter: anioFilter => set({ anioFilter }),

  setActiveTab: activeTab => set({ activeTab }),
  setFacturacionFilter: facturacionFilter => set({ facturacionFilter }),
  setGastoSearchQuery: gastoSearchQuery => set({ gastoSearchQuery }),
  setGastoCentroCostoFilter: gastoCentroCostoFilter => set({ gastoCentroCostoFilter }),
  setExpandedGroups: expandedGroups => set({ expandedGroups }),

  toggleExpandedGroup: descripcion => {
    const prev = get().expandedGroups;
    const next = new Set(prev);
    if (next.has(descripcion)) {
      next.delete(descripcion);
    } else {
      next.add(descripcion);
    }
    set({ expandedGroups: next });
  },

  expandAllGroups: descripciones => {
    set({ expandedGroups: new Set(descripciones) });
  },

  collapseAllGroups: () => {
    set({ expandedGroups: new Set() });
  },

  reset: () => set(initialState),
}));
